<template>
    <div>
        <p class="title is-5">General</p>

        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="kraSettings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <p class="title is-5">KRA</p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.apiHost" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API username (Pin)</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.apiUsername" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API password</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.apiPassword" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <p class="title is-5">MPesa</p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Access Token Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.accessTokenUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Consumer Key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.consumerKey" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Consumer Secret</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.consumerSecret" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Initiator</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.initiator" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Security Credential</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.securityCredential" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sender Shortcode</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.senderShortcode" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Receiver Shortcode</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.receiverShortcode" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Payment Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.paymentUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Notification Url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.mpesa.notificationUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <p class="title is-5">Jobs</p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Email</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="kraSettings.job.email" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label">
            </div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import kraService from '../../../../services/kra.service'
export default {
    name: 'client-settings-kra',
    data() {
      return {
          kraSettings: { mpesa: { } }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    methods: {
      async save() {
        await kraService.save(this.clientId, this.kraSettings);
      }
    },
    async mounted() {
      this.kraSettings = await kraService.getSettingsByClient(this.clientId);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/kra.vue